export default __webpack_public_path__ + "static/media/page-loader-dark.e8e63a7c.gif";